import React from "react";
import { Link } from "react-router-dom";
import { scroller } from "react-scroll";
import "animate.css";
import { PiStarFill } from "react-icons/pi";

const Home = () => {
  const scrollToAbout = () => {
    scroller.scrollTo("about-section", {
      smooth: true,
      offset: -50,
    });
  };

  return (
    <div className="home-div" id="home">
      <h1 className="animate__animated animate__fadeIn">
        Hello! I'm May Phoo Pyae San, a Junior Web Developer.
      </h1>
      <h2 className="animate__animated animate__fadeIn">
        Passionate about creating innovative and user-friendly websites.
      </h2>
      <Link to="/about" onClick={scrollToAbout}>
        <PiStarFill fontSize={50} className="starIcon animate__animated" />
      </Link>
    </div>
  );
};

export default Home;
